// Résolution des pictogrammes d'exercice pour le site.
//
// Symétrique de gymnote/core/pictoResolver.js sur mobile, adapté web :
//   1. imageUrl utilisateur (photo custom) → prefixée via getPhotoUrl
//   2. nom normalisé → picto bundle servi depuis /picto-exo/xxx.png
//   3. cas legacy : ImageUrl serveur "api.gymnote.fr/picto-exo/xxx.png"
//      (URL fictive écrite par les anciennes versions du bundle) → rewrite
//      vers /picto-exo/xxx.png local pour éviter un 404 externe.
//
// Les fichiers PNG sont copiés dans public/picto-exo/ au build (voir README).

import pictoMap from "./exercisePictoMap.json";
import { getPhotoUrl } from "../services/apiConfig";

const normalizeName = (name) => {
	if (!name || typeof name !== "string") return "";
	return name
		.trim()
		.toLowerCase()
		.normalize("NFD")
		.replace(/[̀-ͯ]/g, "")
		.replace(/\s+/g, " ");
};

// Anciens typos corrigés côté mobile (a993c13), gardés ici pour retrouver
// le picto d'un user resté sur l'ancien libellé.
const NAME_ALIASES = {
	"hip trust": "hip thrust",
};

const FAKE_PICTO_HOST = /^https?:\/\/api\.gymnote\.fr\/picto-exo\/(.+)$/i;

// Retourne une URL absolue pour <img src="…"> ou null si rien ne peut être résolu.
export const resolveExercisePicto = (exercise) => {
	if (!exercise) return null;

	const rawImageUrl =
		exercise.ImageUrl != null ? exercise.ImageUrl : exercise.imageUrl;

	// 1) URL legacy pointant vers un host fictif → on récupère juste le nom
	// de fichier et on le sert depuis /picto-exo/ (même origine que le site).
	if (rawImageUrl && typeof rawImageUrl === "string") {
		const m = rawImageUrl.match(FAKE_PICTO_HOST);
		if (m) return `/picto-exo/${m[1]}`;
	}

	// 2) Nom normalisé → picto bundle
	const rawName =
		exercise.NomExercice || exercise.nomExercice || exercise.nom || exercise.name;
	if (rawName) {
		const key = normalizeName(rawName);
		const aliased = NAME_ALIASES[key] || key;
		if (pictoMap[aliased]) return `/picto-exo/${pictoMap[aliased]}`;
	}

	// 3) Photo custom uploadée par l'utilisateur (chemin relatif "uploads/…")
	if (rawImageUrl && typeof rawImageUrl === "string" && rawImageUrl.length > 0) {
		return getPhotoUrl(rawImageUrl);
	}

	return null;
};
